import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loaderActions } from "../redux/slices/loadingSlice";
import { useAppDispatch } from "../redux/store";

const useCookiesCheck = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const cookie = sessionStorage.getItem("lmxBooking");

  useEffect(() => {
    dispatch(loaderActions.hideLoader());
    if (!cookie) {
      console.log("no cookie");
      navigate("//");
    }
  }, []);
};

export default useCookiesCheck;
